import { useEffect, useMemo, useState } from 'react';
import { useLocation, useRoutes } from 'react-router-dom';
import { JWTPayload } from 'jose';
import {
  getDecodedJWT,
  getToken,
  setTokenCookie,
  removeTokenCookie
} from '../../auth/session';
import useRefreshToken from '../../hooks/useRefreshToken';
import ConfigHandler from './ConfigHandler';
import router from '../../router/router';
import SpinnerContainer from '../spinner/SpinnerContainer';

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

function ContentRouter() {
  const content = useRoutes(router);
  const query = useQuery();
  const location = useLocation();
  const [needRedirect, setNeedRedirect] = useState(true);
  const [decodedJwt, setDecodedJwt] = useState<JWTPayload | null>(null);
  let redirect;

  useEffect(() => {
    const token = getToken();
    const credentials = query.get('credentials');
    const params = new URLSearchParams(location.search);
    const finalDecodedJwt = getDecodedJWT(credentials || token);
    setDecodedJwt(finalDecodedJwt);

    if (finalDecodedJwt && credentials) {
      setTokenCookie(credentials);
    }

    redirect =
      // eslint-disable-next-line react-hooks/exhaustive-deps
      !finalDecodedJwt ||
      (finalDecodedJwt &&
        finalDecodedJwt?.exp &&
        Math.floor(Date.now() / 1000) > finalDecodedJwt?.exp);

    if (redirect) {
      removeTokenCookie();
      window.location = `${
        process.env.REACT_APP_API_URL
      }/v1/auth/saml/login?originUrl=${
        location.pathname
      }?${params.toString()}` as any;
    } else {
      setNeedRedirect(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useRefreshToken();

  if (redirect || needRedirect || !decodedJwt) {
    return <SpinnerContainer />;
  }

  return <ConfigHandler>{content}</ConfigHandler>;
}
export default ContentRouter;
